export const DEFAULT_ORGANIZATION_TRASH_RETENTION_DAYS = 30;

export type OrganizationSettingsTrashType = {
    retentionDays: number;
    minimumRetentionDays?: number;
};

export function createDefaultOrganizationTrashSettings(): OrganizationSettingsTrashType {
    return {
        retentionDays: DEFAULT_ORGANIZATION_TRASH_RETENTION_DAYS,
    };
}
